<script>
    import storeHora from '../../../assets/src/Stores/hora-store';
    import Subtitulo from "../../../assets/src/Components/UI/Subtitulo.svelte";
</script>

<header>
    <div class="fecha">
        <Subtitulo icono="calendar_today">{$storeHora.fecha}</Subtitulo>
    </div>

    <div class="hora">
        <Subtitulo icono="access_time">{$storeHora.hora}</Subtitulo>
    </div>
</header>

<style>
    .fecha {
        margin-bottom: var(--padding-global);
    }

    @media only screen and (min-width: 600px) {
        header {
            display: flex;
            font-size: 1em;
        }

        .fecha {
            margin-right: var(--padding-global);
            margin-bottom: 0;
        }
    }
</style>